export var COMPLETED_FILE_STATUS;
(function (COMPLETED_FILE_STATUS) {
    COMPLETED_FILE_STATUS[COMPLETED_FILE_STATUS["Completed"] = 2] = "Completed";
    COMPLETED_FILE_STATUS[COMPLETED_FILE_STATUS["Error"] = 4] = "Error";
    COMPLETED_FILE_STATUS[COMPLETED_FILE_STATUS["Canceled"] = 5] = "Canceled";
    COMPLETED_FILE_STATUS[COMPLETED_FILE_STATUS["Downloaded"] = 6] = "Downloaded";
})(COMPLETED_FILE_STATUS || (COMPLETED_FILE_STATUS = {}));
//# sourceMappingURL=types.js.map